<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useActivity } from "@/stores/activity";
import { onMounted } from "vue";
import Loading from "vue3-loading-overlay";
import { RiArrowRightSLine } from "@remixicon/vue";

const { t } = useI18n();
const activityStore = useActivity();
const { fetchNotifications } = activityStore;

onMounted(async () => {
  await fetchNotifications();
});
</script>
<template>
  <div class="border border-neautrals-200 rounded-md bg-white flex flex-col">
    <div class="flex p-4 items-center justify-between shadow">
      <span class="flex">
        <span class="mr-2">{{ t("dashboard.Notifications") }}</span>
      </span>
      <router-link to="/" class="flex">
        <span class="mr-4 underline font-medium">{{
          t("dashboard.seeAll")
        }}</span>
        <RiArrowRightSLine />
      </router-link>
    </div>
    <div
      class="flex flex-col p-4 flex-col max-h-[190px] overflow-y-auto relative"
    >
      <Loading
        :active="activityStore.isNotificationLoading"
        :is-full-page="false"
        :width="32"
        :height="32"
      />
      <!--
      <div class="flex flex-col">
        <div class="flex mt-4">
          <div class="bg-primary-50 border border-primary-400 rounded-full w-2 h-2 mr-2 flex-shrink-0"></div>
          <span class="text-neautrals-900 font-normal text-xs flex-1">Title</span>
          <span class="text-right text-xxs text-neautrals-500">3 min ago</span>
        </div>
        <p class="text-neautrals-500 text-xs mt-1 mb-1">Do ullamco ex velit anim do proident exercitation et anim tempor.</p>
        <div class="flex">
          <button class="btn btn-default btn-small mr-2">Acept</button>
          <button class="btn btn-default btn-small btn-default-outline">Decline</button>
        </div>
      </div>-->
      <div
        v-if="activityStore.getNotifications.length !== 0"
        v-for="notification in activityStore.getNotifications"
        :key="notification.id"
        class="flex flex-col"
      >
        <div class="flex mt-4">
          <div
            class="bg-primary-50 border border-primary-50 rounded-full w-2 h-2 mr-2 flex-shrink-0"
          ></div>
          <span class="text-neautrals-900 font-normal text-xs flex-1">{{
            notification.title
          }}</span>
          <span class="text-right text-xxs text-neautrals-500">{{
            notification.activityDate
          }}</span>
        </div>
        <p class="text-neautrals-500 text-xs mt-1 mb-1">
          {{ notification.message }}
        </p>
      </div>
    </div>
  </div>
</template>
